import React, { useState } from 'react';
import Header from 'src/routes/Layout/Header';
import { Container } from 'src/routes/Layout/Page/styles';
import collaboratorsService from 'src/service/collaboratorsService';
import { Content, LocalHeader, Title } from '../ReservationReport/styles';
import DataGrid from './components/DataGrid';
import usePaginationObservable from 'src/hooks/usePagination';
import Filters from './components/Filters';
import ButtonNewCollaborator from './components/ButtonNewCollaborator';
import FormNewCollaborator from './components/FormNewCollaborator';

const Collaborators = () => {
  const [params, mergeParams, loading, data, error, , refresh] = usePaginationObservable(
    params => collaboratorsService.listCollaborators(params),
    {},
    []
  );

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalClose = () => {};

  const handleModalCancel = () => {
    setModalOpen(false);
  };

  const handleModalBack = () => {
    setModalOpen(false);
  };

  const openModal = () => {
    setModalOpen(true);
  };
  
  return (
    <Container>
      <Header 
      />
      <Content>
        <LocalHeader>
          <Title>Colaboradores</Title>
          <FormNewCollaborator 
             open={modalOpen}
             handleClose={handleModalClose}
             handleBack={handleModalBack}
             handlecancel={handleModalCancel}
          />
          <ButtonNewCollaborator onClick={openModal}/>
        </LocalHeader>
        <Filters params={params} mergeParams={mergeParams} />
        <DataGrid
          params={params}
          mergeParams={mergeParams}
          loading={loading}
          error={error}
          data={data}
        />
      </Content>
    </Container>
  );
};

export default Collaborators;
